export function getIcon(fieldId: string, value: Readonly<Nullable<string>>) {
  if (fieldId === 'AddonType') {
    switch (value) {
      case 'Split': {
        return 'workspaces';
      }
      case 'Merge': {
        return 'join_full';
      }
      default: {
        return null;
      }
    }
  }
  return null;
}
